import { render, staticRenderFns } from "./AppFrame.vue?vue&type=template&id=59607e02&scoped=true&"
import script from "./AppFrame.vue?vue&type=script&lang=ts&"
export * from "./AppFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59607e02",
  null
  
)

export default component.exports